import React from 'react';
import { GridReactContextProvider } from "../../../Utils/DataGridWrapper/GridContext";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useUserAdminOrgs } from "../../Hooks/UseUserAdminOrgs";
import { SignDocUsersTable } from "../SignDocUsersTable/SignDocUsersTable";
import './SignDocUsersReports.scss';

/**
 * SignDocUsersReports Component
 *
 * Wrapper component for displaying users and their completion status for a specific SignDoc (survey, exam, course, etc.).
 * Provides the necessary context and organization data for the SignDocUsersTable.
 *
 * @param {object} params - Component parameters
 * @param {string} params.signDocId - The SignDoc ID to show users for
 * @param {Array<string>} params.organizationIds - Array of organization IDs to filter users by
 * @param {string} [params.signDocType] - The SignDoc type (e.g., 'EXAM', 'SURVEY', 'ONLINE_COURSE', 'FRONTAL_COURSE')
 * @param {object} [params.signDocData] - The complete SignDoc data object from parent (includes organization assignments, questionnaire data, etc.)
 * @param {Function} [params.onOrganizationFilterChange] - Callback when organization filter changes
 * @param {Function} [params.onReportDataChanged] - Callback when a row's completion changed, so the header stats can be re-read
 * @returns {JSX.Element} Rendered SignDoc users reports component
 */
export const SignDocUsersReports = ({ signDocId, organizationIds, signDocData, adminOrganizationOptions, onOrganizationFilterChange, onReportDataChanged }) => {
    return (
        <div className="SignDocUsersReports">
            <GridReactContextProvider>
                {adminOrganizationOptions ? (
                    <div className="reportDataGridContainer">
                        <SignDocUsersTable
                            signDocId={signDocId}
                            organizationIds={organizationIds}
                            signDocData={signDocData}
                            adminOrganizationOptions={adminOrganizationOptions}
                            onOrganizationFilterChange={onOrganizationFilterChange}
                            onReportDataChanged={onReportDataChanged}
                        />
                    </div>
                ) : (
                    <LoadingSpinner />
                )}
            </GridReactContextProvider>
        </div>
    );
};
